import { render, staticRenderFns } from "./BetterNetworkObservability.vue?vue&type=template&id=52cbd4c2&scoped=true"
import script from "./BetterNetworkObservability.vue?vue&type=script&lang=js"
export * from "./BetterNetworkObservability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cbd4c2",
  null
  
)

export default component.exports